import React from 'react';
import { Flex, Modal, Text, Title } from '@mantine/core';
import Button from '../../components/elements/Button';
import PropTypes from 'prop-types';
import BlockSubMerchantForm from '../../components/forms/BlockSubMerchantForm';

export const RenderModalConfirmationAction = ({
  opened,
  title,
  btnTextPrimary,
  btnTextSecondary,
  contentBody,
  onClose,
  onConfirm
}) => {
  return(
    <Modal centered onClose={onClose} opened={opened}>
      <Title mb="sm" order={3} ta="center">
        {title}
      </Title>
      {contentBody}
      <Flex align="center" gap="sm" mt="sm">
        <Button fullWidth onClick={onClose} style="outlined">{btnTextSecondary}</Button>
        <Button fullWidth onClick={onConfirm}>{btnTextPrimary}</Button>
      </Flex>
    </Modal>
  );
};

RenderModalConfirmationAction.propTypes = {
  btnTextPrimary: PropTypes.string,
  btnTextSecondary: PropTypes.string,
  contentBody: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  opened: PropTypes.bool,
  title: PropTypes.string
};

export const RenderModalLimitRequestPin = ({
  opened,
  contentBody,
  title,
  onClose
}) => {
  return(
    <Modal centered onClose={onClose} opened={opened}>
      <Title mb="md" order={3} ta="center">
        {title}
      </Title>
      {contentBody}
      <Flex align="center" gap="sm" mt="sm">
        <Button fullWidth onClick={onClose}>Tutup</Button>
      </Flex>
    </Modal>
  );
};

RenderModalLimitRequestPin.propTypes = {
  contentBody: PropTypes.node,
  onClose: PropTypes.func,
  opened: PropTypes.bool,
  title: PropTypes.string,
};

export const RenderModalBlockSubMerchant = ({ handleSubmit, opened, onClose }) => {
  return(
    <Modal
      centered
      onClose={onClose}
      opened={opened}
      styles={{
        content: {
          overflowY: 'visible !important'
        },
      }}
      title={<Title fz={30} order={2}>Blokir Subpangkalan</Title>}
    >
      <Text c="#52575C" fz={18} mb="sm">Subpangkalan yang diblokir tidak dapat melakukan transaksi. Apakah Anda yakin untuk memblokir pelanggan?</Text>
      <BlockSubMerchantForm handleSubmit={handleSubmit} onClose={onClose}/>
    </Modal>
  );
};

RenderModalBlockSubMerchant.propTypes = {
  handleSubmit: PropTypes.func,
  onClose: PropTypes.func,
  opened: PropTypes.bool
};
